// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-card[data-v-11b46626]{padding:24px 20px;border-radius:6px;background:#fff;position:relative}.layout-card+.layout-card[data-v-11b46626]{margin-top:15px}.layout-card .head[data-v-11b46626]{font-size:16px;color:#333;margin-bottom:1.5em;line-height:1em;font-weight:700;cursor:default}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
